export const CALCULATOR_MODE = {
  FULL: 'full',
  EDIT: 'edit',
};

export const TAB = {
  FIRST: 0,
  REPEATED: 1,
};

export const calculatorLimitFirst = 'first';
